export const BUSINESS_ONE_KEY = 'BUSINESS_ONE_KEY';
